import React, { createContext, useContext, useState } from "react";
import { getCountriesDropdown } from "../services/CountryService";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

const CountryContext = createContext();

export const useCountry = () => useContext(CountryContext);

export const CountryProvider = ({ children }) => {
  const { auth } = useSelector((state) => state.auth || {});
  const country_id_from_auth = useSelector((state) => state.auth?.country_id);
  
  const [selectedCountry, setSelectedCountry] = useState(country_id_from_auth || 1);
  const [page, setPage] = useState(1);

  // ✅ Fetch countries using useQuery for caching and deduplication
  const { data, isLoading: loading } = useQuery({
    queryKey: ["countriesDropdown", page],
    queryFn: async () => {
      const res = await getCountriesDropdown(page, 10);
      return res.data;
    },
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });

  const countries = data?.data || [];
  const hasMore = data?.pagination ? page < data.pagination.totalPages : false;

  // We keep this for backward compatibility if components call it manually
  const fetchCountries = (pageNum) => {
    setPage(pageNum);
  };

  return (
    <CountryContext.Provider
      value={{
        countries,
        hasMore,
        page,
        loading,
        selectedCountry,
        setSelectedCountry,
        fetchCountries,
        setPage,
      }}
    >
      {children}
    </CountryContext.Provider>
  );
};
